export const setItem = (key: string, value: any) => {
  if (!key || !value) {
    return false;
  }
  localStorage.setItem(key, value);
  return true;
};

export const getItem = (key: string) => localStorage.getItem(key);
export const removeItem = (key: string) => localStorage.removeItem(key);
